import * as React from "react";
import type { SVGProps } from "react";
const SvgKtvBaselineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="ktv_baseline_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M462.336 213.333a42.667 42.667 0 0 1 38.101 24.406l119.68 252.928h-94.464L460.8 353.536l-36.821 73.6a42.667 42.667 0 0 1-74.24 3.627l-6.528-10.368-38.4 70.272h-97.28l95.658-175.019a42.667 42.667 0 0 1 73.558-2.219l4.821 7.68 42.112-84.181a42.667 42.667 0 0 1 38.656-23.595zm252.16 476.928-33.835-71.594H586.24l89.77 189.781a42.667 42.667 0 0 0 77.185-.085l89.429-189.696h-94.336l-33.75 71.594zm-576.81-71.594h97.28l-69.462 127.146a42.667 42.667 0 0 1-74.88-40.96l47.104-86.186zm670.975-128h94.294l31.701-67.158a42.667 42.667 0 0 0-77.227-36.352l-48.768 103.51zm-642.346 29.866H93.867V588.8h72.405v-68.267zm153.6 0h-76.587V588.8h76.544v-68.267zm153.6 0h-76.587V588.8h76.544v-68.267zm153.6 0H550.57V588.8h76.544v-68.267zm153.6 0H704.17V588.8h76.544v-68.267zm149.461 0h-72.405V588.8h72.362v-68.267z"
    />
  </svg>
);
export default SvgKtvBaselineIcon;
